import classNames from 'classnames/bind';

import Chart from 'react-google-charts';

import withComponentName from '../../../decorators/withComponentName';

import teamInfoChart from '../../../assets/about/about_us_profiles/teamInfo.png';
import Styles from '../styles.module.scss';

const dataGender = [
  ['75% Male', 75],
  ['25% Female', 25],
];

const optionsGender = {
  colors: ['#87b5f6', '#3b75c7'],
  pieSliceText: 'none',
  chartArea: {
    width: '100%',
    height: '90%',
  },
  legend: 'none',
  backgroundColor: '#fff',
  tooltip: {
    trigger: 'none',
  },
  fontName: 'Lato',
  enableInteractivity: false,
};

const cx = classNames.bind(Styles);

const AboutUsChartsSection = () => (
  <div className={Styles['about-charts-section']}>
    <div className={Styles.section}>
      <div className={Styles['flex-wrapper']}>
        <div className={Styles['flex-column']}>
          <h4>
            Years working together
          </h4>
          <span className={Styles.subtitle}>As at June 2024</span>
          <div className={Styles['bar-chart-holder']}>
            <img loading="lazy" src={teamInfoChart} alt="teamInfoChart" />
          </div>
        </div>
        <div className={Styles['flex-column']}>
          <h4>Strong Gender Ratio in Tech Industry</h4>
          <div className={Styles['custom-legend']}>
            <div className={cx('custom-legend-text', 'female')}>
              <span>
                {dataGender[1][1]}
                %
              </span>
              Female
            </div>
            <div className={cx('custom-legend-text', 'male')}>
              <span>
                {dataGender[0][1]}
                %
              </span>
              Male
            </div>
          </div>
          <div className={Styles['chart-holder']}>
            <Chart
              chartType="PieChart"
              data={[['Element', ''], ...dataGender]}
              width="150px"
              height="185px"
              options={optionsGender}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default withComponentName(AboutUsChartsSection);
